import PublicNavigationLocations from "core/navigation/PublicNavigationLocations";
import DashboardNavigationLocations from "core/navigation/DashboardNavigationLocations";
import browserPaths from "../../browserPaths";
import { lookup } from "@/utils/lookup";

/**
 * Les adresses du tableau de bord portent le nom de leur destination : `KYB_MANDATES` donne `browserPaths.DASHBOARD.KYB_MANDATES`
 * (absolue) et `KYB_MANDATES_RELATIVE` (relative). Seule l'accueil fait exception : `DASHBOARD` donne `HOME`.
 */
const DASHBOARD_PATHS: Record<string, unknown> = browserPaths.DASHBOARD;

const isDashboardLocation = (location: string): location is DashboardNavigationLocations =>
  (Object.values(DashboardNavigationLocations) as string[]).includes(location);

export default class MapBrowserPath {
  static mapToBrowserPath(
    location: PublicNavigationLocations | DashboardNavigationLocations,
  ): string {
    const publicPath = MapBrowserPath.mapPublicPath(location);
    if (publicPath !== undefined) {
      return publicPath;
    }
    return MapBrowserPath.mapDashboardPath(location, "");
  }

  /** Adresses des pages publiques ; {@code undefined} pour une page du tableau de bord. */
  private static mapPublicPath(
    location: PublicNavigationLocations | DashboardNavigationLocations,
  ): string | undefined {
    switch (location) {
      case PublicNavigationLocations.HOME:
        return browserPaths.HOME;
      case PublicNavigationLocations.FIRST_LOGIN_RESET_PASSWORD:
        return browserPaths.FIRST_LOGIN_RESET_PASSWORD;
      case PublicNavigationLocations.CORPORATE_FIRST_LOGIN:
        return browserPaths.CORPORATE_FIRST_LOGIN;
      default:
        return undefined;
    }
  }

  static mapToBrowserRelativePath(
    location: PublicNavigationLocations | DashboardNavigationLocations,
  ): string {
    return MapBrowserPath.mapDashboardPath(location, "_RELATIVE");
  }

  private static mapDashboardPath(
    location: PublicNavigationLocations | DashboardNavigationLocations,
    suffix: "" | "_RELATIVE",
  ): string {
    const key = location === DashboardNavigationLocations.DASHBOARD ? "HOME" : location;
    const path = isDashboardLocation(location) ? lookup(DASHBOARD_PATHS, key + suffix) : undefined;
    if (typeof path !== "string") {
      throw new TypeError(`Unknown location: ${location}`);
    }
    return path;
  }
}
